import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";


const cities = ["Noida", "Gurugram", "Delhi", "Mumbai"];

export default function Hero() {
    const [cityIndex, setCityIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCityIndex((prevIndex) => (prevIndex + 1) % cities.length);
        }, 2000)
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <Helmet>
                <title>Investycoons | Buy Luxury Apartments & Properties in Delhi NCR</title>
                <meta
                    name="description"
                    content="Explore residential & commercial real estate in Noida, Mumbai, Goa & more. Verified listings, top builders, 0% brokerage. Book your site visit today."
                />
            </Helmet>
            <div className="relative w-full min-h-screen">
                <section className="relative h-screen w-full">
                    <img
                        src={`${process.env.REACT_APP_IMAGEURL}/atshomekraft/hero-1.jpg`}
                        alt="Hero"
                        className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                    <div className="relative z-10 flex flex-col items-start justify-center h-full text-left text-white px-4 sm:px-10 md:px-20">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
                            Your Gateway to Lucrative Real <br /> Estate Investments in{" "}
                            <span className="text-green-400 transition-all duration-500">
                                {cities[cityIndex]}
                            </span>
                        </h1>
                        <p className="text-base sm:text-lg md:text-xl mt-4 max-w-2xl">
                            INTERACT | INVEST | INTACT
                        </p>
                        <Link
                            to="/residential-plot"
                            className="mt-4 px-4 py-2 sm:px-6 sm:py-3 bg-none text-white font-semibold rounded-lg shadow-lg border-2 border-green-500 hover:bg-green-600 transition"
                        > Explore
                        </Link>
                    </div>
                </section>
            </div></>
    )
}